var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t(((_vm.$route.name) + ".title"))))]),_c('h2',[_vm._v(_vm._s(_vm.$t("description")))]),_c('img',{attrs:{"src":_vm.compileFilePath('test.jpg'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }